import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import notificationState from "../../states/notificationState";

import RegisterMachineFailureButton from "../input/RegisterMachineFailureButton";
import FixMachineFailureButton from "../input/FixMachineFailureButton";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

function MomSysMachine ( props ) {

    const [ disableRegisterButton, setDisableRegisterButton ] = useState ();
    const [ disableFixButton, setDisableFixButton ] = useState ();
    const [ machine, setMachine ] = useState ();
    const [ grid, setGrid ] = useState ();
    const [ refresh, setRefresh ] = useState ();
    const setNotification = useSetRecoilState(notificationState);

    useEffect ( () => {

        if ( grid ) {
                
            grid.selectionChanged.addHandler( ( grid ) => {

                setMachine ( grid.selectedItems[0] );

            } );

            grid.itemsSourceChanged.addHandler( ( grid, event ) => {

                if ( grid.selectedItems[0] ) {

                    setMachine ( grid.selectedItems[0] );
        
                }

            } );

        }

    }, [grid] );

    useEffect ( () => {

        if ( machine ) {

            if  ( machine.available === "0" ) {

                setDisableRegisterButton ( true );

            } else {

                setDisableRegisterButton ( false );

            }

            if  ( machine.available === "1" ) {

                setDisableFixButton ( true );

            } else {

                setDisableFixButton ( false );

            }

        } else {

            setDisableRegisterButton ( true );

        }

    }, [machine] );


    const onInitialized = ( grid ) => {

        setGrid ( grid );

    }

    const onApiInitialized = ( api ) => {

        setRefresh ( api );

    }

    const onSuccess = ( msg ) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

        setRefresh ( ( refresh ) => {

            refresh.refresh ();
    
            return refresh;
        })

    }

    const onFailure = ( msg ) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    }

    return (

        <BasicCrudScreenType

            noExcel

            id="MomSysMstMachine"
            table="MomSysMstMachine"
            view="MomSysZvwMachine"
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonAtLast={

                () => (

                    <>
                        <BasicCrudScreenActionItemLayout>
                            <RegisterMachineFailureButton id="MomSysMstMachine" grid={grid} refresh={refresh} disabled={disableRegisterButton} />
                        </BasicCrudScreenActionItemLayout>

                        <BasicCrudScreenActionItemLayout>
                            <FixMachineFailureButton id="MomSysMstMachine" grid={grid} disabled={disableFixButton} onSuccess={onSuccess} onFailure={onFailure} />
                        </BasicCrudScreenActionItemLayout>
                    </>

                )

            }

        />

    )

}

export default MomSysMachine;
